import { WebAppSelection } from "./WebAppSelection";

export class WebAppContextSelection
{
  contextID:string;
  selection:WebAppSelection;
}